/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import ajaxStudent from '../util/remote/ajaxStudent';

const StudentContext = React.createContext();

export const StudentConsumer = StudentContext.Consumer;

export const StudentProvider = (props)=> {

  const [studentList, setStudentList] = useState([]);
  const [schoolStudentList, setSchoolStudentList] = useState([]);

  const [studentsToday, setStudentsToday] = useState([]);
  const [schoolStudentsToday, setSchoolStudentsToday] = useState([]);

  const [studentId, setStudentId] = useState(null);
  const [studentUserId, setStudentUserId] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [schoolPage, setSchoolPage] = useState(1);
  const [schoolMeta, setSchoolMeta] = useState([]);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);

  const [query, setQuery] = useState("");
  const [first, setFirst] = useState("");
  const [schoolQuery, setSchoolQuery] = useState("");
  const [schoolFirst, setSchoolFirst] = useState("");
  const [studentsNumber, setStudentsNumber] = useState(false);
  const [studentProfile, setStudentProfile] = useState(false);

  const [isSorted, setIsSorted] = useState(false);



  useEffect(() => {
    if (schoolId) {
      getSchoolStudentsToday();
    }
  }, [schoolId]);

  useEffect(() => {
    if (studentId) {
      getStudentProfile();
    }
  }, [studentId]);

  

    useEffect(()=>{
         getStudentsNumber();
   }, [])
  
   const getStudentsNumber = async () => {
    setStudentsNumber(false);
    const server_response = await ajaxStudent.fetchAllStudentsNumber();
    if (server_response.status === "OK") {
      //store results
      setStudentsNumber(server_response.details);
    } else {
      //communicate error
      setStudentsNumber("404");
    }
  };

  const getStudentList = async (currentPage) => {
    setStudentList([]);
    setLoading2(true);
    setIsSorted(false);

    const server_response = await ajaxStudent.fetchAllStudents(currentPage);
    setLoading2(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages)
      setStudentList(server_response.details.list || []);
    } else {
      setStudentList([]);
    }
  };

  const sortStudentList = async (currentPage) => {
    setStudentList([]);
    setLoading4(true);
    setIsSorted(true);

    const server_response = await ajaxStudent.sortAllStudents(currentPage);
    setLoading4(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages)
      setStudentList(server_response.details.list || []);
    } else {
      setStudentList([]);
    }
  };


  const getSchoolStudentList = async (currentPage) => {
    if (!schoolId) return;
    setLoading2(true);
    const server_response = await ajaxStudent.fetchStudentList(currentPage, schoolId);
    setLoading2(false);
    if (server_response.status === "OK") {
      setSchoolFirst(server_response.details.meta.offset);
      setSchoolMeta(server_response.details.meta.totalPages);
      setSchoolStudentList(server_response.details.list || []);
    } else {
      setSchoolStudentList([]);
    }
    
  };


  const searchStudents = async (e) => {
    if (e) {
        e.preventDefault();
    }
    setLoading(true);
    setIsSorted(false);

    const server_response = await ajaxStudent.searchAllStudents(query, page);
    setLoading(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages);
      setStudentList(server_response.details.list || []);
      
    } else {
      setStudentList([]);
    }
    
  };

  const searchSchoolStudents = async (e) => {
    if (e) {
      e.preventDefault();
    }
    if (!schoolId) return;

    setLoading(true);
    const server_response = await ajaxStudent.searchSchoolStudents(schoolPage, schoolId, schoolQuery);
    setLoading(false);
    if (server_response.status === "OK") {
        setSchoolFirst(server_response.details.meta.offset);
        setSchoolMeta(server_response.details.meta.list_of_pages);
        setSchoolStudentList(server_response.details.list || []);
    } else {
        setSchoolStudentList([]);
    }
    
  };

  const getStudentProfile = async () => {
    setStudentProfile(false);
    if (!studentId) return;
    setLoading3(true)
    const server_response = await ajaxStudent.fetchStudentData(studentId);
    setLoading3(false)
    if (server_response.status === "OK") {
      //store results
      setStudentProfile(server_response.details);
    } else {
      //communicate error
      setStudentProfile("404");
    }
  };

  const getStudentsToday = async () => {
    const server_response = await ajaxStudent.fetchAllStudentsToday();
    if (server_response.status === "OK") {
      setStudentsToday(server_response.details);
    } else {
      setStudentsToday("404");
    }
  };

  const getSchoolStudentsToday = async () => {
    if (!schoolId) return;
    const server_response = await ajaxStudent.fetchStudentsToday(schoolId);
    if (server_response.status === "OK") {
      setSchoolStudentsToday(server_response.details);
    } else {
      setSchoolStudentsToday("404");
    }
  };
    
    return (
           <StudentContext.Provider value={
               {
                    studentsNumber,
                    studentList,
                    schoolStudentList,
                    studentsToday,
                    schoolStudentsToday,
                    studentId,
                    studentUserId,
                    studentProfile,
                    schoolFirst,
                    schoolId,
                    schoolMeta,
                    schoolPage,
                    schoolQuery,
                    meta,
                    query,
                    page,
                    first,
                    loading,
                    loading2,
                    loading3,
                    loading4,
                    isSorted,

                    setStudentId,
                    setStudentUserId,
                    setSchoolId,
                  getStudentsNumber,
                  getStudentList,
                  getStudentProfile,
                  searchStudents,
                  getStudentsToday,
                  setMeta,
                  setQuery,
                  setPage,
                  setSchoolFirst,
                  setSchoolMeta,
                  setSchoolPage,
                  setSchoolQuery,
                  setIsSorted,
                  searchSchoolStudents,
                  getSchoolStudentList,
                  getSchoolStudentsToday,
                  sortStudentList
                
                
               }
               }>
               {props.children}
           </StudentContext.Provider>
        );
    
}

export default StudentContext;